export default {
  readings: [
    {
      title: "Food Safety Induction",
      id: "pr902-induction-food-safety-at-davin-foods-v1.pdf"
    },
    {
      title: "Managing Food Allergens",
      id: "pr903-induction-allergen-awareness-v2.pdf"
    },
    {
      title: "Health & Safety Overview",
      id: "pr904-induction-hs-overview-v1.pdf"
    },
    {
      title: "Fire Controls and Evacuation",
      id: "pr906-induction-fire-controls-and-evacuation-v1.pdf"
    },
    {
      title: "Manual Handling",
      id: "pr907-induction-manual-handling-v1.pdf"
    },
    {
      title: "Introduction to Chemical Safety and Safe Cleaning Practices",
      id:
        "pr905-induction-coshh-introduction-to-chemicals-and-safe-cleaning-practises-v1.pdf"
    }
  ].sort((a, b) => a.title.localeCompare(b.title))
};
